export enum LoginProviderEnum {
     Native = 0,
     Facebook = 1,
     Apple = 2,
     Google = 3,
     AzureActiveDirectory =4,
  }